
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireebf2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireebf2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("2nLJ0", function(module, exports) {

$parcel$export(module.exports, "provideIntoWindow", function () { return $1bc2bfe99d8ae69c$export$7f4e0cb3d55d3229; });
/**
 * Provide anything into window object
 * @param {string} key - field name
 * @param {any} value - field value
 * @return {value}
 */ function $1bc2bfe99d8ae69c$export$7f4e0cb3d55d3229(key, value) {
    // eslint-disable-next-line
    if (typeof window !== "undefined") // eslint-disable-next-line
    window[key] = value;
    return value;
}

});


var $2nLJ0 = parcelRequire("2nLJ0");
const $d925c6c08d78a28d$export$d964d01f0ef4bf5b = {
    enabled: true,
    layoutMode: "column",
    cssVars: {
        "--pgw-font-family": "Montserrat",
        "--pgw-background-primary": "transparent",
        "--pgw-surface-primary": "#ffffff",
        "--pgw-surface-secondary": "#f6f6f9",
        "--pgw-surface-secondaryHover": "#f0f0f4",
        "--pgw-surface-accent": "#fffae6",
        "--pgw-surface-accentHover": "#fff4c9",
        "--pgw-surface-buttonPrimary": "#09af48",
        "--pgw-surface-buttonPrimaryHover": "#66e38c",
        "--pgw-surface-buttonPrimaryPress": "#078c3a",
        "--pgw-surface-buttonPrimaryDisabled": "#80ec9f",
        "--pgw-surface-buttonSecondary": "#9a85cd",
        "--pgw-surface-buttonSecondaryHover": "#9a85cd",
        "--pgw-surface-buttonSecondaryPress": "#7b6aa4",
        "--pgw-surface-buttonSecondaryDisabled": "#d3c6f4",
        "--pgw-surface-buttonTertiary": "#f0f0f4",
        "--pgw-surface-buttonTertiaryHover": "#e2e2e9",
        "--pgw-surface-buttonTertiaryPress": "#e2e2e9",
        "--pgw-surface-buttonTertiaryDisabled": "#e2e2e9",
        "--pgw-surface-inputPrimary": "#f6f6f9",
        "--pgw-surface-inputSecondary": "#ffffff",
        "--pgw-surface-inputTertiary": "#f0f0f4",
        "--pgw-surface-tab": "#f0f0f4",
        "--pgw-surface-tabHover": "#bfadea",
        "--pgw-surface-tabPress": "#ac98dd",
        "--pgw-surface-negative": "#e76a88",
        "--pgw-surface-positiveAlpha": "#25a8201a",
        "--pgw-surface-skeleton": "#f6f6f926",
        "--pgw-text-primary": "#131325",
        "--pgw-text-secondary": "#646487",
        "--pgw-text-tertiary": "#c5c5d3",
        "--pgw-text-buttonPrimary": "#ffffff",
        "--pgw-text-buttonPrimaryDisabled": "#f0f0f4",
        "--pgw-text-buttonSecondary": "#ffffff",
        "--pgw-text-buttonSecondaryDisabled": "#f0f0f4",
        "--pgw-text-positive": "#24a820",
        "--pgw-text-warning": "#f69230",
        "--pgw-text-negative": "#e76a88",
        "--pgw-text-constant": "#ffffff",
        "--pgw-icon-primary": "#131325",
        "--pgw-icon-secondary": "#646487",
        "--pgw-icon-tertiary": "#c5c5d3",
        "--pgw-icon-buttonPrimary": "#ffffff",
        "--pgw-icon-buttonPrimaryDisabled": "#d5e3f3",
        "--pgw-icon-positive": "#24a820",
        "--pgw-icon-warning": "#f69230",
        "--pgw-icon-negative": "#e76a88",
        "--pgw-stroke-primary": "#f0f0f4",
        "--pgw-stroke-secondary": "#e2e2e9",
        "--pgw-stroke-inputPrimary": "#f0f0f4",
        "--pgw-stroke-inputSecondary": "#e2e2e9",
        "--pgw-stroke-accent": "#ffeeac",
        "--pgw-stroke-accentHover": "#ffe373",
        "--pgw-stroke-positive": "#24a820",
        "--pgw-stroke-positiveAlpha": "#24a8204d",
        "--pgw-stroke-warning": "#f69230",
        "--pgw-stroke-negative": "#e76a88",
        "--pgw-divider-primary": "#f0f0f4",
        "--pgw-border-radius-s": "4px",
        "--pgw-border-radius-m": "8px",
        "--pgw-border-radius-l": "12px",
        "--pgw-border-radius-xl": "16px"
    }
};


const $9390ce6b2a3a9ddc$export$b7c1aa3a66b53a7f = undefined;


var $fca126e2ff67b879$export$a109795f6da16587 = $fca126e2ff67b879$export$a109795f6da16587 || {};
$fca126e2ff67b879$export$a109795f6da16587.scripts = $fca126e2ff67b879$export$a109795f6da16587.scripts || []; // масив скриптів, які будуть додані в дом
$fca126e2ff67b879$export$a109795f6da16587.domain = "https://alfcasino.devv2.space"; // домен апі (рекомендовано залишати пустим)
$fca126e2ff67b879$export$a109795f6da16587.siteDomain = "https://alfcasino.com";
$fca126e2ff67b879$export$a109795f6da16587.siteName = "alf";
$fca126e2ff67b879$export$a109795f6da16587.cdn = "/joxi"; // домен сервера cdn (поки один на всі проекти)
$fca126e2ff67b879$export$a109795f6da16587.apiVersion = "v2"; // версія апі (якщо не вказано, використовується v1)
$fca126e2ff67b879$export$a109795f6da16587.mid = 19; // id пікселя для інкам. ВАЖЛИВО! В кожного сайта своє
$fca126e2ff67b879$export$a109795f6da16587.mobile = true;
$fca126e2ff67b879$export$a109795f6da16587.redirectToNotFound = false;
$fca126e2ff67b879$export$a109795f6da16587.libphonenumber = true;
$fca126e2ff67b879$export$a109795f6da16587.lottielib = true;
$fca126e2ff67b879$export$a109795f6da16587.pgw = (0, $d925c6c08d78a28d$export$d964d01f0ef4bf5b);
$fca126e2ff67b879$export$a109795f6da16587.paynplay = (0, $9390ce6b2a3a9ddc$export$b7c1aa3a66b53a7f);
$fca126e2ff67b879$export$a109795f6da16587.googleAnalytics = {
    appId: "UA-121801220-1",
    trackAs: "AlfCasino"
}; // added googleAnalytics
$fca126e2ff67b879$export$a109795f6da16587.sentry = {
    enabled: true,
    dsn: "https://d4cadb214ab345a6943e820342a2ae18@sentry.gosystem.io/80",
    project: "m_alf_casino"
};
$fca126e2ff67b879$export$a109795f6da16587.places = {
    banner: {
        registration: `'registration_welcome_banner'`
    }
};
$fca126e2ff67b879$export$a109795f6da16587.scss = {
    test: "test"
};
$fca126e2ff67b879$export$a109795f6da16587.symplify = true;


const $de4b7db162e3a11d$export$9af93bb9e9126a2 = {
    home: {
        page: true,
        name: "app.root.layer1.layer2.layer3.home"
    },
    promo: {
        page: true,
        name: "app.root.layer1.layer2.layer3.promos"
    },
    login: {
        page: false,
        name: "login"
    },
    registration: {
        page: false,
        name: "registration"
    },
    paynplay: {
        page: true,
        name: "app.root.layer1.layer2.registration-bank"
    },
    deposit: {
        page: false,
        name: "cashbox",
        private: true
    },
    withdraw: {
        page: false,
        name: "cashbox",
        private: true,
        content: {
            action: "withdrawal"
        }
    },
    realGame: {
        page: true,
        name: "app.root.game.real"
    },
    santa_slope: {
        page: true,
        name: "app.root.game.real",
        params: {
            name: "santas-slope"
        }
    },
    notFound: {
        page: true,
        name: "app.root.layer1.layer2.not-found"
    },
    missedData: {
        page: true,
        name: "app.root.missed-data"
    },
    availableBonuses: {
        page: true,
        name: "app.root.layer1.layer2.account.staff",
        private: true
    },
    bonus_crab: {
        page: true,
        name: "app.root.claw_games.gamepage",
        params: {
            name: "cash-crab"
        }
    },
    cash_crab: {
        page: true,
        name: "app.root.claw_games.gamepage",
        params: {
            name: "cash_crab"
        }
    },
    claw: {
        page: true,
        name: "app.root.claw_games.gamepage"
    },
    balance: {
        page: true,
        name: "app.root.layer1.layer2.account.balance"
    },
    terms: {
        page: true,
        name: "app.root.layer1.layer2.rules"
    },
    profile: {
        page: true,
        name: "app.root.layer1.layer2.account.staff",
        private: true
    },
    contact: {
        page: true,
        name: "app.root.layer1.layer2.contact-us"
    },
    live: {
        page: true,
        name: "app.root.layer1.layer2.layer3.catalog.games",
        params: {
            name: "live-casino",
            collection: "games"
        }
    },
    games: {
        page: true,
        name: "app.root.layer1.layer2.layer3.catalog.games",
        params: {
            name: "all-games",
            collection: "games"
        }
    },
    dropwins: {
        page: true,
        name: "app.root.layer1.layer2.layer3.catalog.games",
        params: {
            name: "dropwins",
            collection: "games"
        }
    },
    evolution: {
        page: true,
        name: "app.root.layer1.layer2.layer3.catalog.providers",
        params: {
            name: "evolution"
        }
    },
    pragmatic: {
        page: true,
        name: "app.root.layer1.layer2.layer3.catalog.providers",
        params: {
            name: "pragmatic"
        }
    },
    threeoaks: {
        page: true,
        name: "app.root.layer1.layer2.layer3.catalog.providers",
        params: {
            name: "threeoaks"
        }
    },
    spinomenal: {
        page: true,
        name: "app.root.layer1.layer2.layer3.catalog.providers",
        params: {
            name: "spinomenal"
        }
    },
    ela: {
        page: true,
        name: "app.root.layer1.layer2.layer3.catalog.providers",
        params: {
            name: "ela"
        }
    },
    playngo: {
        page: true,
        name: "app.root.layer1.layer2.layer3.catalog.providers",
        params: {
            name: "playngo"
        }
    },
    relax: {
        page: true,
        name: "app.root.layer1.layer2.layer3.catalog.providers",
        params: {
            name: "relax"
        }
    },
    skywind: {
        page: true,
        name: "app.root.layer1.layer2.layer3.catalog.providers",
        params: {
            name: "skywind"
        }
    },
    netent: {
        page: true,
        name: "app.root.layer1.layer2.layer3.catalog.providers",
        params: {
            name: "netent"
        }
    },
    pushgaming: {
        page: true,
        name: "app.root.layer1.layer2.layer3.catalog.providers",
        params: {
            name: "pushgaming"
        }
    },
    playtech: {
        page: true,
        name: "app.root.layer1.layer2.layer3.catalog.providers",
        params: {
            name: "playtech"
        }
    },
    quickspin: {
        page: true,
        name: "app.root.layer1.layer2.layer3.catalog.providers",
        params: {
            name: "quickspin"
        }
    },
    redtiger: {
        page: true,
        name: "app.root.layer1.layer2.layer3.catalog.providers",
        params: {
            name: "redtiger"
        }
    },
    halloween: {
        page: true,
        name: "app.root.layer1.layer2.layer3.tournaments"
    },
    tournaments: {
        page: true,
        name: "app.root.layer1.layer2.layer3.tournaments"
    },
    history: {
        page: true,
        name: "app.root.layer1.layer2.account.history"
    },
    // CHRISTMAS
    christmasTournament: {
        page: true,
        name: "app.root.layer1.layer2.layer3.tournaments"
    },
    promotions: {
        page: true,
        name: "app.root.layer1.layer2.layer3.promos"
    }
};


const $7231a392dc32015a$export$5375cda95f0b0eb4 = [
    {
        name: "app.root",
        abstract: true,
        template: "<linda-app linda-zendesk></linda-app>"
    },
    {
        name: "app.root.layer1.layer2.registration-bank",
        url: "/fast-deposit",
        template: "<linda-zimpler-paynplay-page></linda-zimpler-paynplay-page>"
    },
    {
        name: "app.root.paymentcb",
        url: "/payment/:act?order_id&identifier",
        template: "<linda-payment-callback ></linda-payment-callback>"
    },
    {
        name: "app.root.withdraw-paymentcb-success",
        url: "/withdraw-payment/success",
        template: "<linda-withdrawal-payment-callback></linda-withdrawal-payment-callback>",
        params: {
            status: "success"
        }
    },
    {
        name: "app.root.withdraw-paymentcb-fail",
        url: "/withdraw-payment/fail",
        template: "<linda-withdrawal-payment-callback></linda-withdrawal-payment-callback>",
        params: {
            status: "fail"
        }
    },
    // plus sidebar header
    {
        name: "app.root.layer1",
        abstract: true,
        template: "<linda-view-layer-one></linda-view-layer-one>"
    },
    {
        name: "app.root.game",
        abstract: true,
        template: "<linda-game-page></linda-game-page>"
    },
    // <MACHINES>
    {
        name: "app.root.claw_games",
        abstract: true,
        private: true,
        template: "<ui-view></ui-view>"
    },
    {
        name: "app.root.claw_games.gamepage",
        url: "/machine/:name",
        template: "<batman-view-layer1 />"
    },
    // </MACHINES>
    {
        name: "app.root.game.real",
        url: "/play/:name",
        private: true,
        params: {
            mode: "real"
        }
    },
    {
        name: "app.root.game.demo",
        url: "/game/:name",
        params: {
            mode: "demo"
        }
    },
    {
        name: "app.root.layer1.layer2.not-found",
        url: "/404",
        template: "<not-found></not-found>"
    },
    // ======== plus footer ========
    {
        name: "app.root.layer1.layer2",
        abstract: true,
        template: "<linda-view-layer-two></linda-view-layer-two>"
    },
    {
        name: "app.root.layer1.layer2.sitemap",
        url: "/sitemap",
        template: '<linda-sitemap  scroll-to-top="" ></linda-sitemap>'
    },
    {
        name: "app.root.layer1.layer2.privacy-policy",
        url: "/privacy-policy",
        template: '<linda-info-page  scroll-to-top="" ></linda-info-page>',
        params: {
            pageName: "info",
            name: "privacy-policy"
        }
    },
    {
        name: "app.root.layer1.layer2.cookies-policy",
        url: "/cookies-policy",
        template: "<linda-info-page scroll-to-top></linda-info-page>",
        params: {
            pageName: "info",
            name: "cookies-policy"
        }
    },
    {
        name: "app.root.layer1.layer2.about",
        url: "/about",
        template: '<linda-info-page  scroll-to-top="" ></linda-info-page>',
        params: {
            pageName: "info",
            name: "about"
        }
    },
    {
        name: "app.root.layer1.layer2.responsible-gaming",
        url: "/responsible-gaming",
        template: '<linda-info-page  scroll-to-top="" ></linda-info-page>',
        params: {
            pageName: "info",
            name: "responsible-gaming"
        }
    },
    {
        name: "app.root.layer1.layer2.rules",
        url: "/rules",
        template: '<linda-info-page  scroll-to-top="" ></linda-info-page>',
        params: {
            pageName: "info",
            name: "rules"
        }
    },
    {
        name: "app.root.layer1.layer2.faq",
        url: "/faq",
        template: '<linda-info-page  scroll-to-top="" ></linda-info-page>',
        params: {
            pageName: "info",
            name: "faq"
        }
    },
    {
        name: "app.root.layer1.layer2.contact-us",
        url: "/contact-us",
        template: '<linda-info-page  scroll-to-top="" ></linda-info-page>',
        params: {
            pageName: "info",
            name: "contact-us"
        }
    },
    // profile
    {
        name: "app.root.layer1.layer2.account",
        abstract: true,
        template: "<linda-profile-page></linda-profile-page>",
        private: true
    },
    {
        name: "app.root.layer1.layer2.account.staff",
        url: "/account/staff",
        template: "<linda-profile-staff></linda-profile-staff>"
    },
    {
        name: "app.root.layer1.layer2.account.details",
        url: "/account/details",
        template: "<linda-profile-settings></linda-profile-settings>"
    },
    {
        name: "app.root.layer1.layer2.account.verification",
        url: "/account/verification",
        template: "<batman-ui-wrapper1 scroll-to-top></batman-ui-wrapper1>"
    },
    {
        name: "app.root.layer1.layer2.account.balance",
        url: "/account/balance",
        template: "<linda-cashbox-balance></linda-cashbox-balance>"
    },
    {
        name: "app.root.layer1.layer2.account.history",
        url: "/account/history/:type",
        template: "<linda-cashbox-history></linda-cashbox-history>",
        params: {
            type: "deposit"
        }
    },
    // games
    {
        name: "app.root.layer1.layer2.layer3.catalog",
        abstract: true,
        template: "<linda-view-layer-five></linda-view-layer-five>"
    },
    {
        name: "app.root.layer1.layer2.layer3.catalog.favourites",
        url: "/games/favourites",
        template: "<batman-game-box-favourites1></batman-game-box-favourites1>",
        params: {
            collection: "games"
        }
    },
    {
        name: "app.root.layer1.layer2.layer3.catalog.providers",
        url: "/casino-providers/:name",
        template: "<linda-game-hall-providers    ></linda-game-hall-providers>",
        params: {
            pageName: "providers",
            pageType: "",
            collection: "games"
        }
    },
    // =======  plus banner  =======
    {
        name: "app.root.layer1.layer2.layer3",
        abstract: true,
        template: "<linda-view-layer-three></linda-view-layer-three>"
    },
    {
        name: "app.root.layer1.layer2.layer3.home",
        url: "/",
        template: "<linda-homepage></linda-homepage>"
    },
    {
        name: "app.root.layer1.layer2.layer3.promos",
        url: "/promotions",
        template: "<linda-promos></linda-promos>"
    },
    {
        name: "app.root.layer1.layer2.layer3.tournaments",
        url: "/tournaments",
        template: "<linda-tournaments></linda-tournaments>"
    },
    // ======== halloween
    {
        name: "app.root.layer1.layer2.hallsoween",
        url: "/seasons/halloween",
        template: '<halloween-promo-mobile class="halloween-unset halloween-alf" scroll-to-top="" ></halloween-promo-mobile>'
    },
    {
        name: "app.root.layer1.layer2.layer3.vip",
        url: "/vip-service",
        template: "<linda-vip></linda-vip>"
    },
    // ========= app ===========
    // {
    //   name: 'app.root.layer1.layer2.app',
    //   url: '/app',
    //   template: '<linda-mobile-app></linda-mobile-app>',
    // },
    {
        name: "app.root.missed-data",
        url: "/missed-data",
        template: "<linda-missed-data-form></linda-missed-data-form>"
    },
    // =========== seasons ============
    {
        name: "app.root.layer1.layer2.seasons",
        url: "/seasons/:name",
        template: `<linda-promo-wrapper scroll-to-top=""></linda-promo-wrapper>`
    },
    {
        name: "app.root.layer1.layer2.layer3.catalog.games",
        url: "/:collection/:name",
        template: '<batman-game-hall2 scroll-to-top=""></batman-game-hall2>',
        params: {
            collection: "games",
            name: "top"
        },
        onEnter: [
            "casinoResolver",
            function(casinoResolver) {
                casinoResolver.collection();
            }
        ]
    },
    {
        name: "app.root.layer1.layer2.layer3.catalog.collection",
        url: "/:collection",
        template: '<batman-game-hall1 scroll-to-top=""></batman-game-hall1>',
        params: {
            collection: "games"
        },
        onEnter: [
            "casinoResolver",
            function(casinoResolver) {
                casinoResolver.collection();
            }
        ]
    }
];


const $b6945145e5a5455c$export$df0ef5408bae6046 = undefined;


const $d08954e785180626$export$5ee78da69427eb2a = Object.assign({}, (0, $fca126e2ff67b879$export$a109795f6da16587), {
    aliases: $de4b7db162e3a11d$export$9af93bb9e9126a2
}, {
    router: $7231a392dc32015a$export$5375cda95f0b0eb4
}, {
    slider: $b6945145e5a5455c$export$df0ef5408bae6046
});


const $8db7b28d8ea342cc$export$ca0c1c7c8663689b = undefined;


const $55f994a462b34242$var$pgwUrl = "https://app.payment-gateway.io";
const $55f994a462b34242$var$merchantKey = "d8298a74-e5c8-4661-89b2-c15d68804da6";
const $55f994a462b34242$var$productionConfig = {
    pgwConfig: {
        pgwUrl: $55f994a462b34242$var$pgwUrl,
        scriptLoaderUrl: $55f994a462b34242$var$pgwUrl + "/api/widget/loader?merchantKey=" + $55f994a462b34242$var$merchantKey,
        merchantKey: $55f994a462b34242$var$merchantKey,
        pgwPaymentLightSvg: $55f994a462b34242$var$pgwUrl + "/assets/logos/light/large/",
        pgwPaymentDarkSvg: $55f994a462b34242$var$pgwUrl + "/assets/logos/dark/large/"
    }
};
(0, $2nLJ0.provideIntoWindow)("$_ALTENARCONFIG", (0, $8db7b28d8ea342cc$export$ca0c1c7c8663689b));
const $55f994a462b34242$export$5e143010dea16c85 = (0, $2nLJ0.provideIntoWindow)("$_CONFIG", Object.assign({}, (0, $d08954e785180626$export$5ee78da69427eb2a), $55f994a462b34242$var$productionConfig));


//# sourceMappingURL=index.8cd8af2f.js.map
